import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import { COMPANY } from "@/lib/company";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-neutral-950 text-neutral-300 pt-16 lg:pt-20 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-11 h-11 flex items-center justify-center bg-[#C5A059] text-white font-heading font-semibold text-lg">FT</div>
              <div>
                <p className="font-heading text-lg text-white tracking-tight">Fix Technical Renovation Company</p>
                <p className="text-[10px] uppercase tracking-[0.2em] text-[#C5A059]">Premier Interior Fitting · Dubai</p>
              </div>
            </div>
            <p className="text-sm text-neutral-400 leading-relaxed mb-4 max-w-md">
              Renovation and interior fit-out contractor in Dubai serving luxury apartment, villa, penthouse, and commercial clients across Jumeirah, Business Bay, Downtown Dubai, Dubai Marina, and Palm Jumeirah.
            </p>
          </div>

          <div className="lg:col-span-4">
            <p className="text-[10px] uppercase tracking-[0.2em] text-[#C5A059] mb-4">Contact</p>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#C5A059] mt-0.5 flex-shrink-0" />
                <span>{COMPANY.address}</span>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-[#C5A059] mt-0.5 flex-shrink-0" />
                <a href={`tel:${COMPANY.phoneIntl}`} data-testid="footer-phone" className="hover:text-white">{COMPANY.phone}</a>
              </li>
              <li className="flex items-start gap-3">
                <MessageCircle className="w-4 h-4 text-[#25D366] mt-0.5 flex-shrink-0" />
                <a href={COMPANY.whatsappLink} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="hover:text-white">
                  WhatsApp: {COMPANY.whatsapp}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-[#C5A059] mt-0.5 flex-shrink-0" />
                <a href={`mailto:${COMPANY.email}`} data-testid="footer-email" className="hover:text-white">{COMPANY.email}</a>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="text-[10px] uppercase tracking-[0.2em] text-[#C5A059] mb-4">Quick Links</p>
            <ul className="space-y-3 text-sm">
              <li><Link to="/" className="hover:text-white">Home</Link></li>
              <li><Link to="/about-us" data-testid="footer-about" className="hover:text-white">About Us</Link></li>
              <li><a href="/#services" className="hover:text-white">Apartment Renovation Dubai</a></li>
              <li><a href="/#services" className="hover:text-white">Villa Renovation Dubai</a></li>
              <li><a href="/#services" className="hover:text-white">Bathroom Renovation Dubai</a></li>
              <li><a href="/#services" className="hover:text-white">Kitchen Renovation Dubai</a></li>
              <li><Link to="/areas-we-serve" className="hover:text-white">Areas We Serve</Link></li>
              <li><Link to="/privacy-policy" data-testid="footer-privacy" className="hover:text-white">Privacy Policy</Link></li>
              <li><Link to="/terms-and-conditions" data-testid="footer-terms" className="hover:text-white">Terms &amp; Conditions</Link></li>
              <li><a href="/#contact" data-testid="footer-contact" className="hover:text-white">Contact</a></li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-neutral-800 flex flex-col sm:flex-row justify-between gap-3 text-xs text-neutral-500">
          <p>© {new Date().getFullYear()} Fix Technical Renovation Company. All rights reserved.</p>
          <p>Premier Interior Fitting Contractor · Dubai</p>
        </div>
      </div>
    </footer>
  );
}
